<!-- =========================================================================================
    File Name: ServerMonitoringEmail.vue
    Description: ServerMonitoringEmail Page
========================================================================================== -->

<template>
  <div>
    <limit-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"  />
      <vs-button class="overflow-auto m-5" icon-pack="feather" icon="icon-flag" @click="editData">{{$t("THRESHOLDE_MANAGEMENT")}}</vs-button>

      <vx-card :title="this.$t('SERVER MONITORING HISTORY')">
        <div class="pl-5 pt-5">
          <DatePicker lang="en" range v-model="searchDate" :formatter="formatType" value-type="format"  width="60" ></DatePicker>
        </div>
        <p class="p-3 float-right text-base">{{this.$t("TIME_ZONE_MESSAGE")}}</p>

        <div :key="forceRender">
          <vs-tabs position="left" v-if="servers.length">
            <vs-tab v-for="server in servers" :label="getServerLabel(server)" :key="server.serverIp" v-on:click="getServerChart(server.serverIp)">
              <br/>
              <server-monitoring-chart statisticTitle="CPU Load" :chartData="cpuSeries" type='percent'></server-monitoring-chart>
              <br/><hr/>
              <server-monitoring-chart statisticTitle="Memory Usage" :chartData="memorySeries" type='percent'></server-monitoring-chart>
              <br/><hr/>
              <server-monitoring-chart statisticTitle="I/O Throughput" :chartData="ioSeries" type='number'></server-monitoring-chart>
              <br/><hr/>
              <server-monitoring-chart statisticTitle="Disk Usage" :chartData="diskSeries" type='percent'></server-monitoring-chart>
              <br/><hr/>
              <server-monitoring-chart statisticTitle="Network RX" :chartData="networkRxSeries" type='network'></server-monitoring-chart>
              <br/><hr/>
              <server-monitoring-chart statisticTitle="Network TX" :chartData="networkTxSeries" type='network'></server-monitoring-chart>
            </vs-tab>
          </vs-tabs>
        </div>
      </vx-card>
  </div>
</template>

<script>
window.axios = require('axios');

import LimitSidebar from "./ServerMonitoringLimitSidebar.vue"
import moduleSystem from "@/store/system/moduleSystem.js"
import VxCard from '../../../../components/vx-card/VxCard.vue'
import VueApexCharts from 'vue-apexcharts'
import ServerMonitoringChart from './ServerMonitoringChart.vue'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {
    LimitSidebar,
    VxCard,
    VueApexCharts,
    ServerMonitoringChart,
    DatePicker
  },
  data() {
   return {
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      servers: [],
      searchServerIp: '',
      forceRender: 0,
      searchDate: [this.$moment(new Date(new Date() - (1000*60*60*24*7))).format('YYYY-MM-DD'), this.$moment(new Date()).format('YYYY-MM-DD')],
      formatType: {
        stringify: (date) => {
          return date ? moment(new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000)).format('YYYY-MM-DD') : null
        },
        parse: (value) => {
          let date = new Date(value)
          return value ? new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000) : null
        }
      },
      chartOptions: {
            chart: {
                toolbar: { show: true },
                dropShadow: {
                enabled: true,
                top: 5,
                left: 0,
                blur: 4,
                opacity: 0.10,
                },
            },
            stroke: {
                curve: 'smooth',
                dashArray: [0, 10],
                width: [4, 2],
            },
            grid: {
                borderColor: '#e7e7e7',
            },
            legend: {
                show: false,
            },
            colors: ['#9ecc38', '#F97794'],
                fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    inverseColors: false,
                    gradientToColors: ['#3ec9d6', '#7367F0'],
                    shadeIntensity: 1,
                    type: 'horizontal',
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100, 100, 100]
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 5
                }
            },
            xaxis: {
                labels: {
                    style: {
                        cssClass: 'text-grey fill-current',
                    }
                },
                axisTicks: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
            },
            yaxis: {
                tickAmount: 5,
                labels: {
                    style: {
                         cssClass: 'text-grey fill-current',
                    },
                    formatter: function(val) {
                        return val.toLocaleString()+" %";
                    }
                },
            },
            tooltip: {
                x: { show: true }
            }
        }
    }
  },
  created() {
    this.$vs.loading()
    if (!moduleSystem.isRegistered) {
      this.$store.registerModule('dataSystem', moduleSystem)
      moduleSystem.isRegistered = true
    }

    const obj = {
      start : this.$moment(this.searchDate[0]).format('YYYYMMDD')+'000000',
      end : this.$moment(this.searchDate[1]).format('YYYYMMDD')+'235959',
    }

    this.$store.dispatch("dataSystem/fetchServerMonitoringLimit")
    this.$store.dispatch("dataSystem/fetchServerList", obj)       
    .then(() => {
      this.servers = this.serverList
      this.getServerChart(this.serverList[0].serverIp)
      this.$vs.loading.close()
    })
    .catch(error => {
      this.errorAlert(this.$t("ERROR"), error.message)
      this.$vs.loading.close()
    })
  },
  watch:{
    searchDate: function(){
      const obj = {
        start : this.$moment(this.searchDate[0]).format('YYYYMMDD')+'000000',
        end : this.$moment(this.searchDate[1]).format('YYYYMMDD')+'235959',
      }
      this.$store.dispatch("dataSystem/fetchServerList", obj)       
      .then(() => {
        this.servers = this.serverList
        this.getServerChart(this.serverList[0].serverIp)
        this.$vs.loading.close()
      })
      .catch(error => {
        this.errorAlert(this.$t("ERROR"), error.message)
        this.$vs.loading.close()
      })
    },
    servers: function(val){
      this.servers = val
      this.forceRender += 1
    }
  },
  computed:{
    serverList(){
      return this.$store.state.dataSystem.serverList
    },
    cpuSeries(){
      return [
        {
          name: "AVG CPU",
          data: this.$store.state.dataSystem.avgCpuSeries
        },
        {
          name: "MAX CPU",
          data: this.$store.state.dataSystem.maxCpuSeries
        }
      ]
    },
    memorySeries(){
      return [
        {
          name: "AVG MEMORY",
          data: this.$store.state.dataSystem.avgMemorySeries
        },
        {
          name: "MAX MEMORY",
          data: this.$store.state.dataSystem.maxMemorySeries
        }
      ]
    },
    ioSeries(){
      return [
        {
          name: "AVG IO",
          data: this.$store.state.dataSystem.avgIoSeries
        },
        {
          name: "MAX IO",
          data: this.$store.state.dataSystem.maxIoSeries
        }
      ]
    },
    diskSeries(){
      return [
        {
          name: "AVG DISK",
          data: this.$store.state.dataSystem.avgDiskSeries
        },
        {
          name: "MAX DISK",
          data: this.$store.state.dataSystem.maxDiskSeries
        }
      ]
    },
    networkRxSeries(){
      return [
        {
          name: "AVG NETWORK RX",
          data: this.$store.state.dataSystem.avgNRxSeries
        },
        {
          name: "MAX NETWORK RX",
          data: this.$store.state.dataSystem.maxNRxSeries
        }
      ]
    },
    networkTxSeries(){
      return [
        {
          name: "AVG NETWORK TX",
          data: this.$store.state.dataSystem.avgNTxSeries
        },
        {
          name: "MAX NETWORK TX",
          data: this.$store.state.dataSystem.maxNTxSeries
        }
      ]
    }
  },
  methods: {
    // Sidebar
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },
    editData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    getServerLabel(server){
      let name = this.$store.state.commonConfig.serverMonitoring.properties[server.serverId].name
      return name+" ["+server.serverIp+"]"
    },
    getServerChart(serverIp){
      this.$vs.loading()
      this.searchServerIp = serverIp

      const obj = {
        serverIp : serverIp,
        start : this.$moment(this.searchDate[0]).format('YYYYMMDD')+'000000',
        end : this.$moment(this.searchDate[1]).format('YYYYMMDD')+'235959',
      }

      this.$store.dispatch("dataSystem/fetchServerMonitoring", obj)
      .then(() => {
        this.$vs.loading.close()
      })
      .catch(error => { 
        this.errorAlert(this.$t("ERROR"), error.message)
        this.$vs.loading.close()
      })
    },
  },
}

</script>

